import { Api } from "./Api.class";
const endpoint = "referentials";
const referentialAPI = new Api(endpoint);
export default referentialAPI;
